
export default function Trust() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '法令順守',
      description: '出版社から正式に取得し、著作権面もクリア',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: 'ri-trophy-line',
      title: '実績',
      description: '50年以上\n年間利用実績48,000件+ (2024年度)',
      color: 'bg-teal-50 text-teal-600'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '充実なサポート',
      description: 'ご依頼から納品まで丁寧にサポート',
      color: 'bg-purple-50 text-purple-600'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            インフォレスタが選ばれる<br className="sm:hidden" />"3つの安心"
          </h2>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${feature.color} rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6`}>
                <i className={`${feature.icon} text-3xl sm:text-4xl`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 text-center mb-3 sm:mb-4">
                {feature.title}
              </h3>
              <p className="text-xs sm:text-sm text-gray-600 text-center leading-relaxed whitespace-pre-line">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
